import React from 'react';
import Img from 'gatsby-image';

const PreviewCompatibleImage = ({ imageInfo, fluid, style }) => {
  if (!imageInfo && !fluid) {
    return null; // @TODO
  }
  const imageStyle = style || {};
  const { alt = '', childImageSharp, image } = imageInfo || {};

  if (!!fluid) {
    return <Img style={imageStyle} fluid={fluid} alt={alt} />;
  }

  if (!!image && !!image.childImageSharp) {
    return <Img style={imageStyle} fluid={image.childImageSharp.fluid} alt={alt} />;
  }

  if (!!childImageSharp) {
    return <Img style={imageStyle} fluid={childImageSharp.fluid} alt={alt} />;
  }

  if (!!image && typeof image === 'string') return <img style={imageStyle} src={image} alt={alt} />;

  return null;
};

export default PreviewCompatibleImage;
